const actions = {
  SET_STATE: 'bookings/SET_STATE',
  GET_DATA: 'bookings/GET_DATA',
}

export default actions
